import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { employeesWithContract } from 'modules/employees/store/collections/employeesContractVersions'

import { type Memberships } from './collections/memberships'
import { type Teams } from './collections/teams'
import { teamsLedByEmployee } from './teamsLedByEmployee'

export const peopleLedByEmployee = (
  teams: Teams,
  memberships: Memberships,
  employeeId: number,
  contractVersions: ContractVersions
) => {
  const teamIds = teamsLedByEmployee(teams, memberships, employeeId).map(
    (team) => team.attributes.id
  )

  const employeeIds = memberships.models
    .filter((membership) => teamIds.includes(membership.attributes.team_id))
    .map((membership) => membership.attributes.employee_id)

  return employeesWithContract(contractVersions).filter(
    (employeeWithContract) =>
      employeeIds.includes(employeeWithContract.attributes.id) &&
      employeeWithContract.attributes.id !== employeeId
  )
}
